<template>
  <div class="bg-gray-50">
    <div class="max-w-7xl min-h-2/3 mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 flex items-center lg:justify-between flex-col">
      <h2 class="font-extrabold tracking-tight text-gray-900 text-center mx-auto w-1/2">
        <span class="bloc text-3xl">Thank you for your support!</span>
        <span class="block text-indigo-600  text-2xl  my-5">Email has been sent with your receipt!.</span>
      </h2>

      <h4 class="font-extrabold tracking-tight text-center mx-auto w-1/2">
        <span class="bloc text-xl">If you have any issues, please contact contact@barkbadge.com</span>
      </h4>

      <div class="mt-6">
        <button @click="redirect()" class="flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-700">Continue</button>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  name: 'ReceiptResponse',
  components: {
  },
  data(){
    return{
      product: {

      }
    }
  },
  methods:{
    redirect(){
      this.$router.push({name: 'OnboardingMain'})
    }
  },
}
</script>
<style scoped>
</style>
